import enhancedPptxService from './enhancedPptxService';
import { extractSlidesJsonFromDocumentHtml } from '../utils/presentationEmbed';

/**
 * Single entry point for exporting stored document HTML to a .pptx file (browser download).
 */
class PptxExportService {
  /**
   * Export document HTML to PowerPoint, preferring embedded slide JSON when present.
   * @param {string} htmlContent - Stored `generated_documents.content`.
   * @param {string} fileName - Target file name (e.g. `deck.pptx`).
   * @param {string} [_projectName] - Reserved for parity with other export services.
   * @param {object} [options] - Options passed to {@link enhancedPptxService.exportSlidesToPptx}.
   * @returns {Promise<boolean>} True when export succeeded.
   */
  async exportToPptx(htmlContent, fileName, _projectName = '', options = {}) {
    const slides = extractSlidesJsonFromDocumentHtml(htmlContent);
    if (slides && Array.isArray(slides) && slides.length > 0) {
      return enhancedPptxService.exportSlidesToPptx(slides, fileName, options);
    }
    return enhancedPptxService.exportHtmlToPptx(htmlContent, fileName, options);
  }
}

const pptxExportService = new PptxExportService();
export default pptxExportService;
